import { graphql, useFragment } from 'react-relay';

import { TaskDifferenceCounterLabel_difference$key } from '../../../relay/__generated__/TaskDifferenceCounterLabel_difference.graphql';
import { isNullable } from '../../../utils/is';
import CounterLabel, { CounterLabelProps } from '../../core/CounterLabel';

const TaskDifferenceCounterLabel_difference = graphql`
  fragment TaskDifferenceCounterLabel_difference on Difference {
    ... on TaskDifference {
      title {
        __typename
      }
      description {
        __typename
      }
      status {
        __typename
      }
      originalTask {
        __typename
      }
      creationType {
        __typename
      }
      assignedTo {
        __typename
      }
    }
  }
`;

type Props = { difference: TaskDifferenceCounterLabel_difference$key } & CounterLabelProps;

const TaskDifferenceCounterLabel = ({ difference, ...props }: Props) => {
  const { title, description, status, originalTask, creationType, assignedTo } = useFragment(
    TaskDifferenceCounterLabel_difference,
    difference,
  );

  const differenceCount = [title, description, status, originalTask, creationType, assignedTo].filter(
    (diff) => !isNullable(diff),
  ).length;
  return <CounterLabel {...props}>{differenceCount}</CounterLabel>;
};

export default TaskDifferenceCounterLabel;
